/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WidgetService {
    /**
     * Get Salto Widget
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getSaltoWidgetWidgetSaltoGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/salto',
        });
    }
    /**
     * Get Next Match Widget
     * @param teamId
     * @param lang
     * @param theme
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getNextMatchWidgetWidgetNextMatchTeamIdGet(
        teamId: number,
        lang?: (string | null),
        theme: string = 'light',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/next_match/{team_id}',
            path: {
                'team_id': teamId,
            },
            query: {
                'lang': lang,
                'theme': theme,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Last Match Widget
     * @param teamId
     * @param lang
     * @param theme
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getLastMatchWidgetWidgetLastMatchTeamIdGet(
        teamId: number,
        lang?: (string | null),
        theme: string = 'light',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/last_match/{team_id}',
            path: {
                'team_id': teamId,
            },
            query: {
                'lang': lang,
                'theme': theme,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Team Matches Widget
     * @param teamId
     * @param lang
     * @param theme
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getTeamMatchesWidgetWidgetTeamMatchesTeamIdGet(
        teamId: number,
        lang?: (string | null),
        theme: string = 'light',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/team_matches/{team_id}',
            path: {
                'team_id': teamId,
            },
            query: {
                'lang': lang,
                'theme': theme,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Calendar Table Widget
     * @param leagueId
     * @param lang
     * @param theme
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getCalendarTableWidgetWidgetCalendarTableLeagueIdGet(
        leagueId: number,
        lang?: (string | null),
        theme: string = 'light',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/calendar_table/{league_id}',
            path: {
                'league_id': leagueId,
            },
            query: {
                'lang': lang,
                'theme': theme,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Calendar Table Widget Qp
     * @param leagueId
     * @param lang
     * @param theme
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getCalendarTableWidgetQpWidgetCalendarTableGet(
        leagueId: number,
        lang?: (string | null),
        theme: string = 'light',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/calendar_table',
            query: {
                'league_id': leagueId,
                'lang': lang,
                'theme': theme,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Tournament Looser Bracket Widget
     * @param tournamentId
     * @param lang
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getTournamentLooserBracketWidgetWidgetTournamentLooserBracketTournamentIdLangGet(
        tournamentId: number,
        lang: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/tournament/looser_bracket/{tournament_id}/{lang}',
            path: {
                'tournament_id': tournamentId,
                'lang': lang,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Tournament Stages Widget
     * @param tournamentId
     * @param lang
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getTournamentStagesWidgetWidgetTournamentStagesTournamentIdLangGet(
        tournamentId: number,
        lang: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/tournament/stages/{tournament_id}/{lang}',
            path: {
                'tournament_id': tournamentId,
                'lang': lang,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Tournament Groups Widget
     * @param tournamentId
     * @param lang
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getTournamentGroupsWidgetWidgetTournamentGroupsTournamentIdLangGet(
        tournamentId: number,
        lang: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/tournament/groups/{tournament_id}/{lang}',
            path: {
                'tournament_id': tournamentId,
                'lang': lang,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Summercup Widget
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getSummercupWidgetWidgetSummercupGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/widget/summercup',
        });
    }
}
